import { render } from "./VehicleNotes.vue?vue&type=template&id=1513c0fa&scoped=true"
import script from "./VehicleNotes.vue?vue&type=script&lang=js"
export * from "./VehicleNotes.vue?vue&type=script&lang=js"

import "./VehicleNotes.vue?vue&type=style&index=0&id=1513c0fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1513c0fa"]])

export default __exports__